import { useSyncExternalStore } from 'react';
import { instantaneSession, sAbonnerSession, type SessionLocale } from '@/lib/session';

/**
 * Session courante, rafraîchie dès qu'elle change — y compris depuis un autre
 * onglet ou depuis le client HTTP quand le serveur a répondu 401.
 */
export function useSession(): SessionLocale | null {
  return useSyncExternalStore(sAbonnerSession, instantaneSession, () => null);
}
